/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FixIt API
 * Real-time service marketplace API

## Date & time contract

- **Instants** are ISO-8601 UTC ending in `Z` (`format: date-time`); every `*At` field is an instant.
- **Civil days** are bare `YYYY-MM-DD` (`format: date`) and mean that calendar day in the resource's attribution zone (company/contract zone, default Europe/Prague) - never a UTC or device day.
- **Civil months** are `YYYY-MM`, same anchor.
- **Civil-day range params (`dateFrom`/`dateTo`) are both inclusive** at day granularity - `dateTo=2026-05-31` includes the whole of 31 May.
- **Instant range params** (`from`/`to` taking `Z` instants) are half-open `[from, to)`.
- **DST gaps:** a civil day whose local midnight does not exist in its attribution zone starts at the first existing instant of that day (bounds resolve forward, never into the previous day).
 * OpenAPI spec version: 1.0
 */

export enum BozpClientReportKind {
  LANDING_LOADED= 'LANDING_LOADED',
  SESSION_OPEN_FAILED= 'SESSION_OPEN_FAILED',
  CLIENT_ERROR= 'CLIENT_ERROR',

}